import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md'
    },
    
    theme: { 
        themes: {
            light: {
                // primary: '#990000',
                primary: '#5f0032',
                secondary: '#BD9E6E'
            }
        }
    },

});
